import classNames from 'classnames';
import React from 'react';
import { Icon } from '@material-ui/core';
import Button from '../Button';

export interface TagProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;

  /**
   * ラベル
   */
  label?: React.ReactNode;

  /**
   * 左側のボタンアイコン. MaterialIconsのアイコン名が入ります。
   * https://material.io/resources/icons
   */
  leftIcon?: string;
  /**
   * 右側のボタンアイコン. MaterialIconsのアイコン名が入ります。
   * https://material.io/resources/icons
   */
  rightIcon?: string;

  /**
   * アイコンのクラス
   */
  iconClassName?: string;

  /**
   * バッジのタイプ `default`, `info`, `warning`, `important`, `disabled`, `success`
   * カスタムのカラーを使用する場合は backgroundColor を指定する
   */
  type?: "default" | "info" | "warning" | "important" | "disabled" | "success";

  /**
   * 無効かどうか
   */
  disabled?: boolean;

  /**
   * 背景色. typeに該当カラーがない場合に指定する
   */
  backgroundColor?: string;

  /**
   * テキストカラーを白にする
   */
  isColorWhite?: boolean;

  /**
   * タグのクリックが可能かどうか
   */
  isClickable?: boolean;

  /**
   * タグを押した時のアクション
   */
  onClick?: (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => any;

  /**
   * 閉じるボタンを持つかどうか
   */
  hasCloseButton?: boolean;

  /**
   * 閉じるボタンを押した時のアクション
   */
  onClickClose?: (e?: React.MouseEvent<HTMLElement, MouseEvent>) => any;
}

const Tag: React.FC<TagProps> = ({
  className,
  label,
  leftIcon,
  rightIcon,
  iconClassName,
  type = "default",
  disabled = false,
  backgroundColor,
  isColorWhite = false,
  isClickable = false,
  onClick,
  hasCloseButton = false,
  onClickClose,
  ...props
}) => {
  const classes = classNames(
    "uc-tag",
    className,
    type && `uc-tag--${type}`,
    !label && "uc-tag--no-text",
    isClickable && "uc-tag--clickable",
    isColorWhite && "u-text-white",
  )

  return (
    <div
      {...props}
      className={classes}
      onClick={(e) => {
        !disabled && onClick && onClick(e);
      }}
      style={backgroundColor ? { backgroundColor } : {}}
    >
      {leftIcon && <Icon className={classNames("uc-tag__left-icon", iconClassName)}>{leftIcon}</Icon>}
      {label}
      {rightIcon && <Icon className={classNames("uc-tag__right-icon", iconClassName)}>{rightIcon}</Icon>}
      {hasCloseButton &&
        <Button onClick={(e) => {
          e.stopPropagation(); // 親のonClickを抑制
          onClickClose && onClickClose(e);
        }} leftIcon="close" className="uc-tag__close-button" />}
    </div>
  );
}

export default Tag;